/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceScrollNavItem
 */
export interface SurfaceScrollNavItem {
    /**
     * 
     * @type {string}
     * @memberof SurfaceScrollNavItem
     */
    label?: string;
    /**
     * Content block _id or blockId to scroll to
     * @type {string}
     * @memberof SurfaceScrollNavItem
     */
    targetBlockId?: string;
    /**
     * scroll (default) scrolls to target block, modal opens content in a dialog
     * @type {string}
     * @memberof SurfaceScrollNavItem
     */
    action?: SurfaceScrollNavItemActionEnum;
    /**
     * HTML content shown in modal when action is modal (sanitized on frontend via DOMPurify)
     * @type {string}
     * @memberof SurfaceScrollNavItem
     */
    modalHtmlContent?: string;
}


/**
 * @export
 */
export const SurfaceScrollNavItemActionEnum = {
    scroll: 'scroll',
    modal: 'modal'
} as const;
export type SurfaceScrollNavItemActionEnum = typeof SurfaceScrollNavItemActionEnum[keyof typeof SurfaceScrollNavItemActionEnum];


/**
 * Check if a given object implements the SurfaceScrollNavItem interface.
 */
export function instanceOfSurfaceScrollNavItem(value: object): value is SurfaceScrollNavItem {
    return true;
}

export function SurfaceScrollNavItemFromJSON(json: any): SurfaceScrollNavItem {
    return SurfaceScrollNavItemFromJSONTyped(json, false);
}

export function SurfaceScrollNavItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceScrollNavItem {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'targetBlockId': json['targetBlockId'] == null ? undefined : json['targetBlockId'],
        'action': json['action'] == null ? undefined : json['action'],
        'modalHtmlContent': json['modalHtmlContent'] == null ? undefined : json['modalHtmlContent'],
    };
}

export function SurfaceScrollNavItemToJSON(json: any): SurfaceScrollNavItem {
    return SurfaceScrollNavItemToJSONTyped(json, false);
}

export function SurfaceScrollNavItemToJSONTyped(value?: SurfaceScrollNavItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'targetBlockId': value['targetBlockId'],
        'action': value['action'],
        'modalHtmlContent': value['modalHtmlContent'],
    };
}

